import * as React from "react";
import { Button, Modal, Form, Popup } from "semantic-ui-react";
import { Input } from "@neworbit/simpleui-input";
import { ThunkDispatch } from "redux-thunk";

import { Action } from "redux";

import { connect } from "react-redux";
import { IsLoadingButton } from "@teamprevent/common/IsLoadingButton";

import { addBookingNotes } from "../actions";
import { ApplicationState, BookAppointmentTaskListModel } from "../models";
import { ADD_BOOKING_NOTES } from "../actionTypes";

interface Props {
    task: BookAppointmentTaskListModel;
    onSave: (ohCaseId: string, taskId: string, notes: string) => Promise<void>;
}

const NotesButtonUnconnected: React.FunctionComponent<Props> = (props) => {
    const [modalOpen, setModalOpen] = React.useState(false);
    const [notes, setNotes] = React.useState("");

    const onSave = async () => {
        await props.onSave(props.task.ohCaseId, props.task.id, notes);
        setModalOpen(false);
        setNotes("");
    };

    return (
        <>
            <Popup trigger={<Button icon="pen square" onClick={() => setModalOpen(true)} compact />} className="notes-popup">
                {props.task.notes ?
                    <>
                        <h5>Notes:</h5>
                        <div className="book-appointment-card-notes">
                            {props.task.notes}
                        </div>
                    </>:
                    "No notes have been made"
                }
            </Popup>
            <Modal open={modalOpen}>
                <Modal.Content>
                    <Form>
                        <Form.Field>
                            <Input.Textarea label="Previous Notes" value={props.task.notes} readOnly />
                        </Form.Field>
                        <Form.Field>
                            <Input.Textarea label="Notes" value={notes} onChange={n => setNotes(n)} />
                        </Form.Field>
                    </Form>
                </Modal.Content>
                <Modal.Actions>
                    <Button content="Cancel" onClick={() => setModalOpen(false)} />
                    <IsLoadingButton requestNames={ADD_BOOKING_NOTES} content="Save" onClick={onSave} />
                </Modal.Actions>
            </Modal>
        </>
    );
};

const mapDispatchToProps = (dispatch: ThunkDispatch<ApplicationState, undefined, Action>) => ({
    onSave: (ohCaseId: string, taskId: string, notes: string) => dispatch(addBookingNotes(ohCaseId, taskId, notes))
});

export const NotesButton = connect(null, mapDispatchToProps)(NotesButtonUnconnected);
